import Vue from 'vue'
import Vuex from 'vuex'
import { moduleA } from './moduleA'
import { moduleB } from './moduleB'

Vue.use(Vuex)

let state = {

}

let mutations = {

}

let actions = {

}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        moduleA,
        moduleB
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js